module.exports = __webpack_public_path__ + "img/savings-mobile.1eaca760.png";